import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebCaptureService {
  baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) {}

  captureUrl(payload: {
    url: string;
    crawl?: boolean;
    crawl_max_pages?: number;
    crawl_max_depth?: number;
    keywords?: string[];
    ip_address?: string;
    location?: string;
    device?: string;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/web-capture/capture`, payload);
  }

  getHistory(
    page: number,
    limit: number,
    searchKey?: string,
    searchValue?: string,
    startDate?: string,
    endDate?: string,
  ): Observable<any> {
    let params = new HttpParams().set('page', page).set('size', limit);
    if (searchKey) params = params.set('search_key', searchKey);
    if (searchValue) params = params.set('search_value', searchValue);
    if (startDate) params = params.set('start_date', startDate);
    if (endDate) params = params.set('end_date', endDate);
    return this.http.get(`${this.baseUrl}/web-capture/history`, { params });
  }

  deleteHistory(webCaptureIds: string[]): Observable<any> {
    return this.http.delete(`${this.baseUrl}/web-capture/delete`, {
      body: { web_capture_ids: webCaptureIds },
    });
  }

  getJobStatus(jobId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/web-capture/job?job_id=${jobId}`);
  }

  getSearchResults(jobIds: string[]): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/web-capture/job?job_id=${jobIds[0]}`,
    );
  }

  getResults(webCaptureId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/web-capture/results/?web_capture_id=${webCaptureId}`,
    );
  }

  updateCapture(payload: {
    result_id: string;
    notes?: string;
    tags?: string[];
  }): Observable<any> {
    return this.http.put(`${this.baseUrl}/web-capture/update`, payload);
  }

  exportArchive(webCaptureId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${this.baseUrl}/web-capture/archive?web_capture_id=${webCaptureId}`,
      { responseType: 'blob', observe: 'response' },
    );
  }

  exportReport(webCaptureId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${this.baseUrl}/web-capture/report?web_capture_id=${webCaptureId}`,
      { responseType: 'blob', observe: 'response' },
    );
  }

  getSimilarCaptures(webCaptureId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/web-capture/similar?web_capture_id=${webCaptureId}`,
    );
  }
}
